<template>
    <section class='main'>
        <div class='crumbs'>
            <el-breadcrumb separator='/'>
                <el-breadcrumb-item><i class='el-icon-lx-profile'></i> 项目相关</el-breadcrumb-item>
                <el-breadcrumb-item>项目自定义配置</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        
        <div class='container' style='min-width: 900px'>
            <div class='plugins-tips'>
                <el-row>
                    <el-col :span='22'>
                        <el-form v-show='showSearch' ref='queryForm' :inline='true' :model='queryParams' size='small'>
                            <el-form-item style='margin-bottom: 0'>
                                <el-select filterable clearable size='mini' v-model='queryParams.projectAppId'
                                           placeholder='项目名'>
                                    <el-option
                                        v-for='item in projectInfoList'
                                        :key='item.id'
                                        :label='item.cnName'
                                        :value='item.id'>
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item style='margin-bottom: 0'>
                                <el-button icon='el-icon-search' size='mini' type='primary' @click='handleQuery'>搜索
                                </el-button>
                                <el-button icon='el-icon-refresh' size='mini' @click='resetQuery'>重置</el-button>
                            </el-form-item>
                        </el-form>
                    </el-col>
                    <el-col :span='2'>
                        <el-row class='mb8'>
                            <el-col :span='8'>
                                <el-button
                                    icon='el-icon-plus'
                                    plain
                                    size='mini'
                                    type='primary'
                                    @click='handleAdd'
                                >新增
                                </el-button>
                            </el-col>
                        </el-row>
                    </el-col>
                </el-row>
            </div>
            
            
            <el-table v-loading='loading' :cell-style="{ textAlign: 'center' }" :data='projectSettingList'
                      @selection-change='handleSelectionChange'>
                <!--<el-table-column align='center' type='selection' width='55' />-->
                <el-table-column :show-overflow-tooltip='true' align='center' label='项目名'>
                    <template slot-scope='scope'>
                        <span>{{ projectInfoMap.get(scope.row.projectAppId) }}</span>
                    </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip='true' align='center' label='最后更新时间' prop='updateTime' />
                <el-table-column fixed='right' align='center' width='200' class-name='small-padding fixed-width'
                                 label='操作'>
                    <template slot-scope='scope'>
                        <el-button
                            icon='el-icon-edit'
                            size='mini'
                            type='text'
                            @click='handleUpdate(scope.row)'
                        >修改
                        </el-button>
                        <el-button
                            icon='el-icon-delete'
                            size='mini'
                            type='text'
                            @click='handleDelete(scope.row)'
                        >删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            
            <div class='pagination'>
                <el-pagination
                    :current-page='queryParams.pageNum'
                    :page-size='queryParams.pageSize'
                    :total='queryParams.total'
                    background
                    layout='prev, pager, next'
                    @current-change='handlePagination'>
                </el-pagination>
            </div>
            
            <!-- 添加或修改参数配置对话框 -->
            <el-dialog :title='title' :before-close='cancel' :visible.sync='open' append-to-body width='40%'>
                <el-form label-position='right' ref='form' label-width='100px'>
                    <el-form-item v-if='!this.updateStatus' label='项目名' prop='url'>
                        <el-select size='mini' filterable :disabled='updateStatus'
                                   v-model='currentProjectSetting.projectAppId' placeholder='请选择'>
                            <el-option
                                v-for='item in projectInfoList'
                                :key='item.id'
                                :label='item.cnName'
                                :value='item.appId'>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <cotton-dynamic-form warning-type='warning'
                                         @getDynamicJsonString='getDynamicJsonString' json-key='settingJson'
                                         :json-object='currentEditingSetting'>
                    </cotton-dynamic-form>
                </el-form>
                <div slot='footer' class='dialog-footer'>
                    <el-button type='primary' @click='submitForm'>确 定</el-button>
                    <el-button @click='cancel'>取 消</el-button>
                </div>
            </el-dialog>
        </div>
    </section>
</template>

<script>

import { message } from '@/utils/message';
import { deepCopy } from '@/utils/object';
import { queryProjectSetting } from '@/components/api/ProjectSetting';
import { queryProjectInfoList } from '@/components/api/ProjectInfo';
import { queryAntiAddictionSetting } from '@/components/api/AntiAddictionSetting';
import { projectCustomSettingApi } from '@api/ProjectInfo/projectCustomSetting';
import CottonDynamicForm from '@/components/component/CottonDynamicForm.vue';

export default {
    name: 'Dict',
    components: { CottonDynamicForm },
    data() {
        return {
            projectSettingList: [],
            // 遮罩层
            loading: true,
            // 选中数组
            ids: [],
            batchDeleteStatus: false,
            // 显示搜索条件
            showSearch: true,
            // 弹出层标题
            title: '',
            // 是否显示弹出层
            open: false,
            // 查询参数
            queryParams: {
                total: 0,
                pageNum: 1,
                pageSize: 15,
                projectAppId: undefined
            },
            updateStatus: false,
            currentProjectSetting: {},
            
            currentEditingSetting: {
                settingJson: ''
            },
            currentJsonSetting: {},
            projectInfoMap: new Map,
            antiAddictionMap: new Map,
            antiAddictionList: [],
            projectInfoList: [],
            allProjectSettingList: [],
            openCopyProjectSetting: false,
            copyProjectSettingId: undefined
        };
    },
    created() {
        this.getList();
    },
    computed: {
        computeAlterMsg() {
            if (this.currentProjectSetting.projectId) {
                return '拷贝已经存在的项目防沉迷设置作为 ' + this.projectInfoMap.get(this.currentProjectSetting.projectId) + ' 项目的防沉迷设置';
            }
            return '拷贝已经存在的项目防沉迷设置作为  项目的防沉迷设置';
        }
    },
    methods: {
        handlePagination(pageNum) {
            this.queryParams.pageNum = pageNum;
            this.getList();
        },
        handleAddSetting() {
            this.$router.push('antiAddictionSetting');
        },
        /** 查询字典类型列表 */
        getList() {
            this.reset();
            this.loading = true;
            projectCustomSettingApi.query(this.queryParams).then(response => {
                if (response.code === 200) {
                    this.projectSettingList = response.data.result;
                    this.queryParams.total = response.data.total;
                    this.loading = false;
                    this.queryParams.pageNum = response.data.pageNum;
                } else {
                    this.loading = false;
                }
            });
            
            // 查询项目信息
            queryProjectInfoList({ pageSize: 100000 }).then(result => {
                if (result.code === 200) {
                    if (result.data && result.data.result) {
                        result.data.result.forEach(v => {
                            this.projectInfoList.push(v);
                            this.projectInfoMap.set(v.appId, v.cnName);
                        });
                    }
                }
            });
            
            // 查询防沉迷模板
            queryAntiAddictionSetting({ pageSize: 100000 }).then(result => {
                if (result.code === 200) {
                    if (result.data && result.data.result) {
                        result.data.result.forEach(v => {
                            this.antiAddictionMap.set(v.id, v);
                            this.antiAddictionList.push(v);
                        });
                    }
                }
            });
            
            this.queryAllProjectSetting();
        },
        getDynamicJsonString(jsonValue) {
            console.log('获取到最新数据', jsonValue);
            this.currentJsonSetting = JSON.parse(jsonValue);
        },
        // 取消按钮
        cancel() {
            this.open = false;
            this.getList();
        },
        // 表单重置
        reset() {
            this.projectSettingList = [];
            this.projectInfoList = [];
            this.projectInfoMap = new Map;
            this.antiAddictionMap = new Map;
            this.antiAddictionList = [];
            this.currentProjectSetting = {
                settingData: ''
            };
        },
        /** 搜索按钮操作 */
        handleQuery() {
            this.queryParams.pageNum = 1;
            this.getList();
        },
        /** 重置按钮操作 */
        resetQuery() {
            this.queryParams = {};
            this.handleQuery();
        },
        /** 新增按钮操作 */
        handleAdd() {
            
            this.open = true;
            this.title = '增加项目自定义设置';
            this.updateStatus = false;
            this.currentProjectSetting = {
                settingJson: ''
            };
        },
        handleBatchDelete() {
            let idList = this.ids;
            const obj = this;
            
        },
        // 多选框选中数据
        handleSelectionChange(selection) {
            this.ids = selection.map(item => item.id);
            this.batchDeleteStatus = this.ids.length > 0;
        },
        /** 修改按钮操作 */
        handleUpdate(row) {
            this.currentJsonSetting = {};
            this.currentEditingSetting = {};
            this.open = true;
            this.title = '修改项目自定义设置';
            this.updateStatus = true;
            this.currentProjectSetting = deepCopy(row);
            if (this.currentProjectSetting.setting) {
                this.currentJsonSetting = this.currentProjectSetting.setting;
                this.currentEditingSetting.settingJson = JSON.stringify(this.currentProjectSetting.setting);
            }
        },
        /** 提交按钮 */
        async submitForm() {
            this.currentProjectSetting.setting = this.currentJsonSetting;
            if (this.updateStatus) {
                projectCustomSettingApi.update(this.currentProjectSetting).then(result => {
                    if (result.code === 200) {
                        message.success('修改成功');
                        this.getList();
                        this.open = false;
                    }
                });
            } else {
                if (!this.currentProjectSetting.projectAppId) {
                    message.error('请选择项目名');
                    return;
                }
                projectCustomSettingApi.insert(this.currentProjectSetting).then(result => {
                    if (result.code === 200) {
                        message.success('添加成功');
                        this.getList();
                        this.open = false;
                    }
                });
            }
        },
        /** 删除按钮操作 */
        handleDelete(row) {
            this.$modal.confirm('是否确认删除"' + row.id + '"的数据项？').then(function() {
                return projectCustomSettingApi.deleteData(row);
            }).then((result) => {
                if (result.code === 200) {
                    this.getList();
                    this.$modal.msgSuccess('删除成功');
                }
            }).catch(() => {
            });
        },
        queryAllProjectSetting() {
            queryProjectSetting({ pageNum: 1, pageSize: 100000 }).then(result => {
                if (result.code === 200 && result.data.result) {
                    this.allProjectSettingList = result.data.result;
                }
            });
        },
        handleCopyProjectSetting() {
            this.openCopyProjectSetting = true;
        },
        submitCopyProjectSetting() {
            let obj = this;
            this.$modal.confirm('此操作会删除该项目已有的防沉迷设置').then(() => {
                this.currentProjectSetting.settingData = undefined;
                this.allProjectSettingList.forEach((item) => {
                    if (this.copyProjectSettingId === item.id) {
                        this.currentProjectSetting.settingData = item.settingData;
                        this.openCopyProjectSetting = false;
                        this.copyProjectSettingId = undefined;
                    }
                });
            });
        }
    }
};
</script>
<style>

</style>